const BOSelect = ({ onChange, options, value }) => {
	return (
		<select
			id="category"
			name="category"
			value={value}
			onChange={onChange}
			className="transition duration-300 bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70 text-white px-4 py-2 rounded-lg"
		>
			{options.length > 0 &&
				options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
		</select>
	);
};

export default BOSelect;
